module.exports = __webpack_public_path__ + "img/My_Feedback.c2ceaea6.svg";